import { Database } from '@nozbe/watermelondb';

import adapter from './adapter';
import models from './models';

// Then, make a Watermelon database from it!
const database = new Database({
  adapter,
  modelClasses: models,
  actionsEnabled: true,
});

export default database;
